// src/Cog.js
import React, { useRef } from 'react';
import { useFrame, useLoader } from '@react-three/fiber';
import * as THREE from 'three';

export function Cog({ position = [0, 0, 0], size = 1 }) {
  const meshRef = useRef();

  const texture = useLoader(THREE.TextureLoader, '/GameLogo.png');

  // Rotate the image slowly
  useFrame(() => {
    if (meshRef.current) {
      meshRef.current.rotation.z += 0.01;
    }
  });

  return (
    <mesh ref={meshRef} position={position} scale={[size, size, size]}>
      <planeGeometry args={[1, 1]} />
      <meshBasicMaterial
        map={texture}
        transparent
        side={THREE.DoubleSide}
      />
    </mesh>
  );
}
